import axios from 'axios'
import Cookies from 'js-cookie'
import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

export default {
  increaseCount(state) {
    state.count += 5
  },
  updateUsers(state, users) {
    state.users = users
  },
  login(state, userInfo) {
    state.userInfo = userInfo
  },
  logOut(state) {
    state.userInfo = null
    removeToken()
    Cookies.remove('isLogin')
    Cookies.remove('Admin-Token')
    Cookies.remove('X-Dts-Token')
  },
  setUser(state, user) {
    if(!!user){
      setToken(user.token)
      let userInfo = user.userInfo
      if(!!!userInfo.carts){
        userInfo.carts = []
      }
      userInfo.name = userInfo.nickname
      userInfo.headImg = userInfo.avatar
      userInfo.isPlus = 1
      state.userInfo = userInfo
      //创建有效期为7天的cookie
      Cookies.set('isLogin', 'true', {
        expires: 7,
      })
    }

  },
  loadDefaultUsers(state) {
    let users = localStorage.getItem('users')
    console.log('这里是loadDefaultUsers方法')
    if (!users) {
      // 如果不存在用户，就读取默认用户
      axios({
        type: 'get',
        url: '/static/data/default-users.json',
      })
        .then((res) => {
          console.log(res.data)
          localStorage.setItem('users', JSON.stringify(res.data))
          state.users = JSON.parse(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      state.users = JSON.parse(users)
    }
  },
  getUsersAndCheck(state, info) {
    // 获取所有用户到 state.users
    let users = undefined; //localStorage.getItem('users')
    console.log('这里是getUsersAndCheck方法')
    console.log('这是用户信息')
    console.log(info.userInfo)
    let userInfo = info.userInfo
    if (!users) {
      // 登录
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          setToken(res.data.token)
          let userInfo = res.data.userInfo
          if(!!!userInfo.carts){
            userInfo.carts = []
          }
          userInfo.name = userInfo.nickname
          userInfo.headImg = userInfo.avatar
          userInfo.isPlus = 1
          state.userInfo = userInfo
          //创建有效期为7天的cookie
          Cookies.set('isLogin', 'true', {
            expires: 1,
          })
          // localStorage.setItem('users', JSON.stringify(userInfo));
          info.that.$router.go(-1)
          // commit('SET_TOKEN', res.token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })




      // 如果不存在用户，就读取默认用户
      // axios({
      //   type: 'get',
      //   url: '/static/data/default-users.json',
      // })
      //   .then((res) => {
      //     console.log(res.data)
      //     localStorage.setItem('users', JSON.stringify(res.data))
      //     state.users = JSON.parse(res.data)
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //   })

    } else {
      state.users = JSON.parse(users)
    }

    // checkinfo.userInfo
    users = state.users
    console.log('这里是全部用户的信息')
    console.log(users)

    let newArr = users.filter((item) => {
      return item.username === info.userInfo.username
    })
    console.log(newArr)

    if (newArr.length === 0) {
      info.that.$message({
        showClose: true,
        message: '警告，用户名错误',
        type: 'error',
      })
      return false
    } else {
      if (newArr[0].password !== info.userInfo.password) {
        info.that.$message({
          showClose: true,
          message: '警告，密码错误',
          type: 'error',
        })
        return false
      } else {
        info.that.$message({
          showClose: true,
          message: '恭喜你, 登录成功',
          type: 'success',
        })

        state.userInfo = newArr[0]

        console.log('----------------')
        console.log('登录成功')

        //创建有效期为7天的cookie
        Cookies.set('isLogin', 'true', {
          expires: 7,
        })

        // window.$cookies.set('userInfo', 'JSON.stringify(newArr[0])', '7d');

        info.that.$router.go(-1)
        return true
      }
    }
  },
  checkRegAndAdd(state, info) {
    // 获取所有用户到 state.users
    let users = localStorage.getItem('users')
    console.log('这里是checkRegAndAdd方法')
    console.log('这是用户信息')
    console.log(info.userInfo)
    if (!users) {
      // 如果不存在用户，就读取默认用户
      axios({
        type: 'get',
        url: '/static/data/default-users.json',
      })
        .then((res) => {
          console.log(res.data)
          localStorage.setItem('users', JSON.stringify(res.data))
          state.users = JSON.parse(res.data)
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      state.users = JSON.parse(users)
    }

    users = JSON.parse(users)
    console.log(users)

    let newArr = users.filter((item) => {
      return item.username === info.userInfo.username
    })
    console.log(newArr)

    if (newArr.length !== 0) {
      info.that.$message({
        showClose: true,
        message: '警告，该用户名已被注册',
        type: 'error',
      })
      return false
    } else {
      info.that.$message({
        showClose: true,
        message: '注册成功',
        type: 'success',
      })

      let defaultUser = {
        username: 'admin',
        password: '123456',
        name: '何玉洁',
        email: 's.zoq@vuyydkhus.sb',
        age: 18,
        headImg: '/static/images/headImg/5.jpg',
        isPlus: 1,
        carts: [],
      }
      defaultUser.username = info.userInfo.username
      defaultUser.name = info.userInfo.username
      defaultUser.password = info.userInfo.password

      users.push(defaultUser)
      console.log(users)
      localStorage.setItem('users', JSON.stringify(users))
      return true
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js